import { useMemo } from "react";

import { useLevelContext } from "sj-ui-toolkit/src/atlas/contexts/Level/LevelContextProvider";
import { useEnrollments } from "sj-ui-toolkit/src/api/hooks";
import { useBreadcrumb } from "sj-ui-toolkit/src/atlas/hooks/useBreadcrumbs";
import { PageBreadcrumb } from "sj-ui-toolkit/src/atlas/components";

import { LearninGrid } from "../LearninGrid/LearninGrid";
import { getEnrolledRoleIds, questsToLearnins } from "../../helpers/learnins";

const QuestsPage = () => {
  const { quests, isLoading } = useLevelContext();
  const { data: enrollments = [] } = useEnrollments();

  useBreadcrumb({ label: "Quests", route: "/quests", display: "page" });

  const items = useMemo(() => {
    const enrolledQuestRoleIds = getEnrolledRoleIds(
      (enrollments ?? []).filter(e => e.enrollmentType === "quest")
    );
    return questsToLearnins(quests, enrolledQuestRoleIds);
  }, [quests, enrollments]);

  return (
    <div data-testid="learn-quests-page">
      <PageBreadcrumb />
      <LearninGrid
        items={items}
        loading={isLoading}
        variant="indigo"
        pathType="Quest"
        title="Quests"
        searchInputId="quests-search"
      />
    </div>
  );
};

export default QuestsPage;
